import { createSlice } from "@reduxjs/toolkit";
const slice = createSlice({
    name:'ProductsFilter',
    initialState:{title:'',price:'',size:'',color:''},
    reducers:{
        addFilter:(state, action)=> {
            state.title = action.payload.title
            state.price = action.payload.price
            state.size = action.payload.size
            state.color = action.payload.color
        },
        delFilter:(state)=>{
            state.title = ''
            state.price = ''
            state.size = ''
            state.color = ''
        }
    }
})

export default slice.reducer;
export const {addFilter} = slice.actions